<template>
  <div>
    <div id="components-form-demo-advanced-search">
      <a-form layout="inline" class="ant-advanced-search-form">
        <a-row>
          <a-col :span="6">
            <a-form-item label="客户名称">
              <a-input size="small" v-model="queryParam.query_nickName_like" placeholder="客户名称"/>
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <a-form-item label="备注">
              <a-input size="small" v-model="queryParam.query_note_like" placeholder="备注"/>
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <a-form-item label="性别">
              <a-select
                size="small"
                v-model="queryParam.query_gender_eq"
                defaultValue
                width="200px"
              >
                <a-select-option value>--请选择--</a-select-option>
                <a-select-option
                  v-for="option in gender"
                  v-bind:key="option.value"
                >{{ option.text }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <template v-if="advanced">
            <a-col :span="6">
              <a-form-item label="客户类型">
                <a-select size="small" v-model="queryParam.query_customerType_eq" defaultValue>
                  <a-select-option value>--请选择--</a-select-option>
                  <a-select-option
                    v-for="option in customerType"
                    v-bind:key="option.value"
                  >{{ option.text }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :span="6">
              <a-form-item label="电话">
                <a-input size="small" v-model="queryParam.query_phone_like" placeholder="电话"/>
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="advanced && { float: 'right', overflow: 'hidden', } || {} "
            >
              <a-button size="small" type="primary" @click="reloadTable">查询</a-button>
              <a-button style="margin-left: 8px" size="small" @click="queryParamRest">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <p></p>

    <a-table
      ref="table"
      bordered
      :columns="columns"
      rowKey="id"
      :dataSource="data"
      :pagination="pagination"
      :pageSizeOptions="pagination.pageSizeOptions"
      :loading="loading"
      @change="handleTableChange"
    >
      <span slot="action" slot-scope="text, record">
        <a-button size="small" @click="goToUpdate(record.id)">修改</a-button>
        <a-divider type="vertical"/>
        <a-button size="small" type="danger" @click="deleteById(record.id)">删除</a-button>
      </span>

      <span slot="gender" slot-scope="text">{{text | dictText(gender)}}</span>
      <span slot="customerType" slot-scope="text,record">
        <a-select
          :defaultValue="''+record.customerType"
          style="width: 120px"
          @change="updateCustomerType($event,record.id)"
        >
          <a-select-option v-for="option in customerType" :key="option.value">{{ option.text }}</a-select-option>
        </a-select>
      </span>
    </a-table>
  </div>
</template>
<script>
export default {
  name: "userIndex",
  mounted() {},
  created() {
    this.$http
      .get("/api/1.0/dict/list", { "query-ownGroup-eq": "Gender" })
      .then(res => {
        this.gender = res.data;
      });
    this.$http
      .get("/api/1.0/dict/list", { "query-ownGroup-eq": "CustomerGroup" })
      .then(res => {
        this.customerType = res.data;
      });
    this.queryParamRest();
    // this.reloadTable();
  },
  data() {
    return {
      advanced: false,
      queryParam: {},
      customerType: [],
      gender: [],
      data: [], //渲染表格数据
      pagination: {
        pageSizeOptions: ["10", "20", "30", "40", "50"],
        current: 1,
        defaultCurrent: 1,
        pageSize: 10,
        defaultPageSize: 10,
        total: 0,
        showSizeChanger: true,
        showTotal: total => `Total ${total} items`
      },
      loading: false,
      columns: [
        {
          title: "客户名称",
          dataIndex: "nickName",
          queryname: "query-nickName-eq",
          key: "query-nickName-eq",
          width: "20%",
          sorter: true
        },
        {
          title: "电话",
          dataIndex: "phone",
          width: "20%",
          key: "query-phone-like",
          sorter: true
        },
        {
          title: "性别",
          key: "query-gender-eq",
          dataIndex: "gender",
          sorter: true,
          scopedSlots: { customRender: "gender" }
        },
        {
          title: "客户类型",
          key: "query-customerType-eq",
          dataIndex: "customerType",
          sorter: true,
          scopedSlots: { customRender: "customerType" }
        },
        {
          title: "备注",
          key: "query-note-like",
          dataIndex: "note",
          width: "20%"
        },
        {
          title: "操作时间",
          key: "query-updateTime-eq",
          dataIndex: "updateTime",
          sorter: true
        },
        {
          title: "操作",
          key: "action",
          scopedSlots: { customRender: "action" }
        }
      ]
    };
  },
  methods: {
    handleTableChange(pagination, filters, sorter) {
      this.fetch(
        this.$http.initParams(pagination, filters, sorter, this.queryParam)
      );
    },
    fetch(params = {}) {
      this.loading = true;
      this.$http.get("/api/1.0/account/page", params).then(res => {
        const data = res.data;
        this.data = data.records;
        const pagination = { ...this.pagination };
        pagination.total = data.total;
        pagination.pageSize = data.size;
        pagination.current = data.current;
        this.pagination = pagination;
      });
      this.loading = false;
    },
    onShowSizeChange: () => {
      this.pagination.pageSize = pageSize;
    },

    queryParamRest() {
      this.queryParam = { query_gender_eq: "", query_roleId_eq: "" };
      this.reloadTable();
    },
    reloadTable() {
      this.handleTableChange(this.pagination, null, null, this.queryParam);
    },
    deleteById: function(id) {
      this.$http.get("/api/1.0/account/delete/" + id).then(res => {
        this.reloadTable();
      });
    },
    goToUpdate(id) {
      this.$router.push({
        path: "/user/update/" + id
      });
    },

    toggleAdvanced() {
      this.advanced = !this.advanced;
    },
    updateCustomerType(customerType, userId) {
      console.log("roleId:", customerType);
      console.log("userId:", userId);
      this.$http
        .post("/api/1.0/account/update", {
          id: userId,
          customerType: customerType
        })
        .then(res => {
          if (res.code === 200) {
            this.$message.info("更新成功");
          }
        });
    }
  }
};
</script>

<style scoped>
.ant-advanced-search-form .ant-form-item {
  margin-bottom: 0px;
}
.custom-filter-dropdown {
  padding: 8px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
.ant-advanced-search-form {
  padding: 12px;
  background: #fbfbfb;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
}
</style>